module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile"
  }, [_c('sui-header'), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-third"
  }, [_c('div', {
    staticClass: "is-hidden-mobile"
  }, [_c('profile-header-narrow', {
    attrs: {
      "person": _vm.person
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "is-hidden-tablet"
  }, [_c('profile-header-mobile', {
    attrs: {
      "person": _vm.person
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column is-two-thirds"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column level is-mobile"
  }, [_c('router-link', {
    staticClass: "level-item has-text-centered",
    attrs: {
      "to": {
        name: 'profile/items',
        params: {
          profileId: _vm.profileId
        }
      }
    }
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.person.stats.item))]), _vm._v(" "), _c('p', [_vm._v("Items")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "level-item has-text-centered",
    attrs: {
      "to": {
        name: 'profile/collections',
        params: {
          profileId: _vm.profileId
        }
      }
    }
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.person.stats.collection))]), _vm._v(" "), _c('p', [_vm._v("Collections")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "level-item has-text-centered",
    attrs: {
      "to": {
        name: 'profile/following',
        params: {
          profileId: _vm.profileId
        }
      }
    }
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.person.stats.followee))]), _vm._v(" "), _c('p', [_vm._v("Following")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "level-item has-text-centered",
    attrs: {
      "to": {
        name: 'profile/followers',
        params: {
          profileId: _vm.profileId
        }
      }
    }
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.person.stats.follower))]), _vm._v(" "), _c('p', [_vm._v("Followers")])])])], 1)]), _vm._v(" "), _c('router-view', {
    attrs: {
      "person": _vm.person
    }
  })], 1)])])]), _vm._v(" "), _c('sui-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-76cc7b08"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfileLayout--NarrowWide.vue
// module id = 289
// module chunks = 1